import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
import * as turf from '@turf/turf'
/**
 * 风险区域图层
 */
export default class RiskAreaLayer extends BaseLayer{

    constructor(options={}){
        options.layerName=options.layerName||CONSTANTS.LAYER.RISKAREA;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        data.map((obj,index) =>{
            let item={...obj};
            item.layerName=self.layerName;
            item.coords=Array.isArray(item.coords) ? item.coords:JSON.parse(item.coords||"[]");
            if(item.coords.length > 3){
                let positions=[],coordinates=[],longitude,latitude;
                for(let coord of item.coords){
                  longitude=Number(coord[0]),latitude=Number(coord[1]);
                  coordinates.push([longitude,latitude]);
                  positions.push(Cesium.Cartesian3.fromDegrees(longitude,latitude));
                }
                item.coordinates=coordinates;
                let color;
                switch (item.color) {
                  case "重大风险":
                    color="#ff0000";//红色
                    break;
                  case "较大风险":
                    color="#ffa500";//橙色
                    break;
                  case "一般风险":
                    color="#ffff00";//黄色
                    break;
                  case "低风险":
                    color="#0000ff";//蓝色
                    break;
                  default:
                    color="#0000ff";//红色

                }
                let centroid = turf.getCoord(turf.centroid(turf.polygon([coordinates])));//获取线段中心点
                let entity = new Cesium.Entity({
                    id:item.id,
                    attributes:item,
                    position:Cesium.Cartesian3.fromDegrees(centroid[0],centroid[1],Number(item.height||20)),
                    polygon: {
                        hierarchy: positions,
                        extrudedHeight: Number(item.height||20),
                        material:Cesium.Color.fromCssColorString(color).withAlpha(0.7)
                    },
                    label:{
                        text : item.riskName,
                        font: "16px Helvetica",
                        fillColor: Cesium.Color.WHITE,
                        outlineColor: Cesium.Color.BLACK,
                        outlineWidth: 2,
                        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                        showBackground: false,
                        //垂直位置
                        //verticalOrigin : Cesium.VerticalOrigin.BUTTON,
                        //中心位置
                        pixelOffset : new Cesium.Cartesian2(0, -30),
                        //解决绘制几何图形被高程遮挡
                        //disableDepthTestDistance:Number.POSITIVE_INFINITY,
                        //distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 35000)
                    }
                });
                self.dataSource.entities.add(entity);
            }
        });
    }
};
